var _rect, _rect2, _rect3, _line, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeActivityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 172,
    viewBox: "0 0 348 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 348,
    height: 172,
    rx: 7,
    fill: "#EFEFEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 12,
    width: 64.0005,
    height: 14,
    rx: 7,
    fill: "#8C8C8C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 12,
    width: 14.0001,
    height: 14,
    rx: 7,
    fill: "#D9D9D9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    x1: 10,
    y1: 161.676,
    x2: 338,
    y2: 161.676,
    stroke: "#B1B1B1",
    strokeWidth: 0.647727
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 131,
    width: 31,
    height: 6,
    rx: 3,
    transform: "rotate(90 51 131)",
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 114,
    width: 48,
    height: 6,
    rx: 3,
    transform: "rotate(90 63 114)",
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 137,
    width: 25,
    height: 6,
    rx: 3,
    transform: "rotate(90 75 137)",
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 147,
    width: 15,
    height: 6,
    rx: 3,
    transform: "rotate(90 87 147)",
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 131,
    width: 31,
    height: 6,
    rx: 3,
    transform: "rotate(90 99 131)",
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 145,
    width: 17,
    height: 6,
    rx: 3,
    transform: "rotate(90 111 145)",
    fill: "#D9D9D9"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 150,
    width: 12,
    height: 6,
    rx: 3,
    transform: "rotate(90 123 150)",
    fill: "#D9D9D9"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 139,
    width: 23,
    height: 6,
    rx: 3,
    transform: "rotate(90 135 139)",
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 6,
    rx: 3,
    transform: "matrix(2.63403e-08 -1 -1 -7.25385e-08 147 162)",
    fill: "#D9D9D9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 131,
    width: 31,
    height: 6,
    rx: 3,
    transform: "rotate(90 159 131)",
    fill: "#D9D9D9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 135,
    width: 27,
    height: 6,
    rx: 3,
    transform: "rotate(90 171 135)",
    fill: "#D9D9D9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 142,
    width: 20,
    height: 6,
    rx: 3,
    transform: "rotate(90 183 142)",
    fill: "#D9D9D9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 124,
    width: 38,
    height: 6,
    rx: 3,
    transform: "rotate(90 195 124)",
    fill: "#D9D9D9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 137,
    width: 25,
    height: 6,
    rx: 3,
    transform: "rotate(90 207 137)",
    fill: "#D9D9D9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 131,
    width: 31,
    height: 6,
    rx: 3,
    transform: "rotate(90 219 131)",
    fill: "#D9D9D9"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 124,
    width: 38,
    height: 6,
    rx: 3,
    transform: "rotate(90 231 124)",
    fill: "#D9D9D9"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 147,
    width: 15,
    height: 6,
    rx: 3,
    transform: "rotate(90 243 147)",
    fill: "#D9D9D9"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 127,
    width: 35,
    height: 6,
    rx: 3,
    transform: "rotate(90 255 127)",
    fill: "#D9D9D9"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 114,
    width: 48,
    height: 6,
    rx: 3,
    transform: "rotate(90 267 114)",
    fill: "#D9D9D9"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 124,
    width: 38,
    height: 6,
    rx: 3,
    transform: "rotate(90 279 124)",
    fill: "#D9D9D9"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 291,
    y: 147,
    width: 15,
    height: 6,
    rx: 3,
    transform: "rotate(90 291 147)",
    fill: "#D9D9D9"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 137,
    width: 25,
    height: 6,
    rx: 3,
    transform: "rotate(90 303 137)",
    fill: "#D9D9D9"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 42,
    width: 76.0005,
    height: 50,
    rx: 4,
    fill: "#D9D9D9"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 82,
    width: 63.0004,
    height: 4,
    rx: 2,
    fill: "#9095A1",
    fillOpacity: 0.27
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 76,
    width: 63.0004,
    height: 4,
    rx: 2,
    fill: "#9095A1",
    fillOpacity: 0.27
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 48,
    width: 30.0002,
    height: 14,
    rx: 7,
    fill: "#9095A1",
    fillOpacity: 0.27
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 42,
    width: 76.0005,
    height: 50,
    rx: 4,
    fill: "#D9D9D9"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 82,
    width: 63.0004,
    height: 4,
    rx: 2,
    fill: "#9095A1",
    fillOpacity: 0.27
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 76,
    width: 63.0004,
    height: 4,
    rx: 2,
    fill: "#9095A1",
    fillOpacity: 0.27
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 48,
    width: 30.0002,
    height: 14,
    rx: 7,
    fill: "#9095A1",
    fillOpacity: 0.27
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 42,
    width: 76.0005,
    height: 50,
    rx: 4,
    fill: "#D9D9D9"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 82,
    width: 63.0004,
    height: 4,
    rx: 2,
    fill: "#9095A1",
    fillOpacity: 0.27
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 76,
    width: 63.0004,
    height: 4,
    rx: 2,
    fill: "#9095A1",
    fillOpacity: 0.27
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 48,
    width: 30.0002,
    height: 14,
    rx: 7,
    fill: "#9095A1",
    fillOpacity: 0.27
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 42,
    width: 76.0005,
    height: 50,
    rx: 4,
    fill: "#D9D9D9"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 82,
    width: 63.0004,
    height: 4,
    rx: 2,
    fill: "#9095A1",
    fillOpacity: 0.27
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 76,
    width: 63.0004,
    height: 4,
    rx: 2,
    fill: "#9095A1",
    fillOpacity: 0.27
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 48,
    width: 30.0002,
    height: 14,
    rx: 7,
    fill: "#9095A1",
    fillOpacity: 0.27
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeActivityIcon);
export default __webpack_public_path__ + "static/media/time-activity-icon.84d7530252539af177e0c865c6412395.svg";
export { ForwardRef as ReactComponent };